module.exports = __webpack_public_path__ + "static/assets/5ffd28542539e5d2bf2e6e2c16788255.svg";